import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-resultado-acordo',
  templateUrl: './dialog-resultado-acordo.component.html',
  styleUrls: ['./dialog-resultado-acordo.component.scss']
})
export class DialogResultadoAcordoComponent {

  constructor(
    public dialogRef: MatDialogRef<DialogResultadoAcordoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      sucessos: string[];
      erros: string[];
    }
  ) {}

  fechar(): void {
    this.dialogRef.close();
  }

  get titulo(): string {
  const total =
    (this.data.sucessos?.length || 0) +
    (this.data.erros?.length || 0);

    return total === 1
      ? 'Resultado do Acordo'
      : 'Resultados dos Acordos';
  }
}
